import _ from 'lodash';
import { useEffect, useState } from 'react';
import DragDropper, { dragDropperTypes } from '../../dragNDrops/DragDropper';
import { labels } from './labels';

const LabelSort = (props) => {

  const { viewKey, display_propItem, updateArray, allowSort, allowRandom, headerColor, additionalProps, sortData } = props
  const { sortGroupName } = display_propItem ?? {}

  const [groups, setGroups] = useState()
  const [dndGroups, setDDGroups] = useState()

  const portalCn = 'portal'

  useEffect(() => {
    const { groups: _groups } = sortData ?? {}
    if (_groups) {
      const _ddGroups = {}
      _.forEach(_groups, (group, groupKey) => {
        const lbProps = { items: group.items, viewKey, additionalProps }
        _ddGroups[groupKey] = {
          dataItems: group.items,
          elements: labels(lbProps)
        }
      })
      setDDGroups(_ddGroups)
    }
    setGroups(_groups)
    // eslint-disable-next-line
  }, [sortData && sortData.groups]);


  const handleSorted = (dndGroups) => updateArray(dndGroups)

  const dragDropper = () => <DragDropper
    allowSort={allowSort}
    dndType={dragDropperTypes.label}
    dndGroups={dndGroups}
    display_propItem={display_propItem}
    groupChangeKey={sortGroupName}
    handleSorted={handleSorted}
    headerColor={headerColor}
    isLabelSort={true}
    portalCn={portalCn}
  />

  return groups && dndGroups ? dragDropper() : <div></div>

}

export default LabelSort